import { DashboardTabTypes } from '@interfaces/DashboardTabTypes.enum';
import { updateActiveMainPageLayout } from '@store/slices/mainPageLayout.slice';

export const updateMainPageLayout = (activeMainPageLayout: DashboardTabTypes | null) => (dispatch) => {
	dispatch(updateActiveMainPageLayout({ activeMainPageLayout: activeMainPageLayout }));
};
